<template>
  <div class="wrapper" id="chartPage">
    <div class="actBar" v-if="ifPrint">
      <el-form :inline="true">
        <el-form-item>
          <el-select
            v-model="examinationId"
            size="small"
            placeholder="搜索考试名称"
          >
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.examName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getData"
            >查询</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="printPage"
            v-if="areaPrintReady && normalPrintReady"
            >下载</el-button
          >
        </el-form-item>
        <!-- getPdf() -->
      </el-form>
    </div>
    <div
      id="htmlToPdf"
      style="padding: 20px 25px 50px 25px"
      v-if="!pageRefresh"
    >
      <h1 style="margin: 30px auto" v-if="examinationId">
        {{ examList.find((item) => item.id == examinationId).examName }}
      </h1>
      <h2 style="margin: 30px auto">整体情况分析</h2>

      <div
        class="tableBox"
        style="
          display: flex;
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          text-align: center;
          flex-wrap: wrap;
          font-size: 16px;
          line-height: 42px;
        "
      >
        <div
          class="cell"
          style="
            width: 20%;
            box-sizing: border-box;
            border-right: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
          "
          v-for="totalTitle in [
            '最高分',
            '最低分',
            '平均分',
            '通过率',
            '80分以上',
          ]"
          :key="'totalTitle' + totalTitle"
        >
          {{ totalTitle }}
        </div>
        <div
          class="cell"
          style="
            width: 20%;
            box-sizing: border-box;
            border-right: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
          "
          v-for="totalKey in [
            'maxScore',
            'minScore',
            'avgScore',
            'passPercentage',
            'greatPercentage',
          ]"
          :key="'totalKey' + totalKey"
        >
          {{ examBaseInfo[totalKey] }}
        </div>
      </div>
      <h2 style="margin: 50px auto 30px">参考人员地区分布</h2>

      <div
        class="areaTable"
        style="
          border-left: 1px solid #ccc;
          border-top: 1px solid #ccc;
          page-break-after: always;
          line-height: 42px;
        "
      >
        <div
          v-for="item in [1, 2, 3]"
          :key="'areaTableCell' + item"
          style="
            width: 33.3%;
            display: inline-flex;
            font-size: 16px;
            line-height: 42px;
            text-indent: 5px;
          "
        >
          <div
            style="
              font-weight: bold;
              flex: 3;
              border-right: 1px solid #ccc;
              border-bottom: 1px solid #ccc;
              text-indent: 5px;
            "
          >
            地区
          </div>
          <div
            style="
              font-weight: bold;
              flex: 2;
              border-right: 1px solid #ccc;
              border-bottom: 1px solid #ccc;
              text-indent: 5px;
            "
          >
            参考人数
          </div>
        </div>

        <div
          v-for="item in areaTableOption"
          :key="'areaTable' + item.cityString"
          style="
            width: 33.3%;
            display: inline-flex;
            font-size: 14px;
            line-height: 42px;
          "
        >
          <div
            style="
              flex: 3;
              border-right: 1px solid #ccc;
              border-bottom: 1px solid #ccc;
              text-indent: 5px;
            "
          >
            {{ item.cityString }}
          </div>
          <div
            style="
              flex: 2;
              border-right: 1px solid #ccc;
              border-bottom: 1px solid #ccc;
              text-indent: 5px;
            "
          >
            {{ item.num }}
          </div>
        </div>
      </div>
      <h2 style="margin-top: 15px">各地区情况统计</h2>
      <!-- <div
        v-for="(dou, douIdx) in doubleAreaOptionList.slice(0, 1)"
        :key="'dou0' + douIdx"
        style="margin-bottom: 10px; page-break-after: always"
      >
        <div
          class="areaChartListContainer"
          style="display: flex; flex-flow: wrap; justify-content: space-between"
        >
          <div
            v-for="(item, index) in dou"
            :key="'areaCell' + item.cityString"
            style="width: 49%; display: block"
          >
            <h3 class="title">{{ index + 1 }}、{{ item.cityString }}</h3>

            <div style="border: 1px solid #ccc">
              <div
                style="
                  display: flex;
                  flex-flow: wrap;
                  font-size: 16px;
                  line-height: 24px;
                  text-indent: 5px;
                "
              >
                <div
                  style="
                    width: 25%;
                    border-right: 1px solid #ccc;
                    border-bottom: 1px solid #ccc;
                    box-sizing: border-box;
                    font-size: 15px;
                  "
                  :style="index == 3 ? 'border-right: 0' : ''"
                  v-for="(key, index) in [
                    '参考人数',
                    '通过人数',
                    '不通过人数',
                    '通过率',
                  ]"
                  :key="'areaTable' + key"
                >
                  {{ key }}
                </div>

                <div
                  style="
                    width: 25%;
                    border-right: 1px solid #ccc;
                    border-bottom: 1px solid #ccc;
                    box-sizing: border-box;
                  "
                  :style="index == 3 ? 'border-right: 0' : ''"
                  v-for="(key, index) in [
                    'applyTotal',
                    'passNum',
                    'failNum',
                    'passPercentage',
                  ]"
                  :key="'area' + key"
                >
                  {{ item[key] }}
                </div>
              </div>
              <div
                style="
                  width: 95%;
                  display: block;
                  height: 500px;
                  margin: auto;
                  transform: translate3D(-12%, 0, 0);
                "
                :id="'areaChart' + item.cityString"
              ></div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- --------- -->
      <div
        v-for="(dou, douIdx) in doubleAreaOptionList"
        :key="'dou' + douIdx"
        style="margin-bottom: 10px; padding-top: 30px; page-break-after: always"
      >
        <div
          class="areaChartListContainer"
          style="display: flex; flex-flow: wrap; justify-content: space-between"
        >
          <div
            v-for="(item, index) in dou"
            :key="'areaCell' + item.cityString"
            style="width: 49%; display: block"
          >
            <h3 class="title">
              {{ douIdx * 2 + index + 1 }}、{{ item.cityString }}
            </h3>

            <div style="border: 1px solid #ccc">
              <div
                style="
                  display: flex;
                  flex-flow: wrap;
                  font-size: 16px;
                  line-height: 24px;
                  text-indent: 5px;
                "
              >
                <div
                  style="
                    width: 25%;
                    border-right: 1px solid #ccc;
                    border-bottom: 1px solid #ccc;
                    box-sizing: border-box;
                    font-size: 15px;
                  "
                  :style="index == 3 ? 'border-right: 0' : ''"
                  v-for="(key, index) in [
                    '参考人数',
                    '通过人数',
                    '不通过人数',
                    '通过率',
                  ]"
                  :key="'areaTable' + key"
                >
                  {{ key }}
                </div>

                <div
                  style="
                    width: 25%;
                    border-right: 1px solid #ccc;
                    border-bottom: 1px solid #ccc;
                    box-sizing: border-box;
                  "
                  :style="index == 3 ? 'border-right: 0' : ''"
                  v-for="(key, index) in [
                    'applyTotal',
                    'passNum',
                    'failNum',
                    'passPercentage',
                  ]"
                  :key="'area' + key"
                >
                  {{ item[key] }}
                </div>
              </div>
              <div
                style="
                  width: 95%;
                  display: block;
                  height: 800px;
                  margin: auto;
                  transform: translate3D(-12%, 0, 0);
                "
                :id="'areaChart' + item.cityString"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div
      class="areaChartListContainer"
      style="display: flex; flex-flow: wrap; justify-content: space-between"
    >
      <div
        v-for="(item, index) in areaOptionList"
        :key="'areaCell' + item.cityString"
        style="
          width: 49%;
          break-after: always;
          display: block;
          page-break-after: always;
        "
      >
        <h3 class="title">{{ index + 1 }}、{{ item.cityString }}</h3>

        <div style="border: 1px solid #333">
          <div
            style="
              display: flex;
              flex-flow: wrap;
              font-size: 16px;
              line-height: 24px;
              text-indent: 5px;
            "
          >
            <div
              style="
                width: 25%;
                border-right: 1px solid #333;
                border-bottom: 1px solid #333;
              "
              :style="index == 3 ? 'border-right: 0' : ''"
              v-for="(key, index) in [
                '参考人数',
                '通过人数',
                '不通过人数',
                '通过率',
              ]"
              :key="'areaTable' + key"
            >
              {{ key }}
            </div>

            <div
              style="
                width: 25%;
                border-right: 1px solid #333;
                border-bottom: 1px solid #333;
              "
              :style="index == 3 ? 'border-right: 0' : ''"
              v-for="(key, index) in [
                'applyTotal',
                'passNum',
                'failNum',
                'passPercentage',
              ]"
              :key="'area' + key"
            >
              {{ item[key] }}
            </div>
          </div>
          <div
            style="width: 100%; height: 600px; margin: auto"
            :id="'areaChart' + item.cityString"
          ></div>
        </div>
      </div>
    </div> -->
      <div
        v-for="item in chartNameList"
        :key="item"
        class="chartContainer"
        style="padding-top: 20px; height: 550px"
      >
        <div
          style="width: 95%; display: block; height: 400px; margin: auto"
          :id="item"
        ></div>
        <div v-if="item == 'passRateAndAnswerTimeOption'">
          <div
            style="
              display: flex;
              border-top: 1px solid #ccc;
              border-left: 1px solid #ccc;
              flex-flow: wrap;
              font-size: 14px;
              line-height: 24px;
              text-indent: 5px;
            "
          >
            <div
              style="
                width: 16.66%;
                border-right: 1px solid #ccc;
                border-bottom: 1px solid #ccc;
                box-sizing: border-box;
              "
              v-for="key in [
                '时间段',
                '0-29：59',
                '30：00-44：59',
                '45：00-59：59',
                '1:00:00-1:29:59',
                '1:30:00-1:59:59',
                '交卷率',
                'a',
                'b',
                'c',
                'd',
                'e',
                '累计交卷率',
                'a1',
                'b1',
                'c1',
                'd1',
                'e1',
              ]"
              :key="'uploadInRangeTime' + key"
            >
              {{ turnoverRateAndTime[key] ? turnoverRateAndTime[key] : key }}
            </div>
          </div>
        </div>
        <div class="tips" style="font-size: 16px; width: 600px; margin: auto">
          {{ chartData[item].optionRemark }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import {
  ageDistributionChart,
  detailedAnalysisByRegion,
  getExamList,
} from "@/api/index.js";
export default {
  data() {
    return {
      chartData: {},
      chartNameList: [],
      areaChartNameList: [],
      examinationId: "",
      areaTableOption: [],
      areaOptionList: [],
      examList: [],
      areaPrintReady: false,
      normalPrintReady: false,
      ifPrint: true,
      pageRefresh: false,
      turnoverRateAndTime: {},
      doubleAreaOptionList: [],
      examBaseInfo: {
        avgScore: 0,
        greatNum: 0,
        greatPercentage: 0,
        maxScore: 0,
        minScore: 0,
        passNum: 0,
        passPercentage: 0,
        total: 0,
      },
    };
  },
  methods: {
    getPdf() {
      var title =
        this.examList.find((item) => item.id == this.examinationId).examName +
        "考试分析";
      html2Canvas(document.getElementById("htmlToPdf"), {
        allowTaint: true,
      }).then(function (canvas) {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 592.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new JsPDF("", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        setTimeout(() => {
          PDF.save(title + ".pdf");
        }, 1000);
      });
    },
    printPage() {
      this.ifPrint = false;
      // 获取画布的对象(canvas)
      this.chartNameList.forEach((item) => {
        var mycanvas = document
          .getElementById(item)
          .getElementsByTagName("canvas")[0];
        if (mycanvas) {
          var parent = mycanvas.parentElement;

          var image = mycanvas.toDataURL("image/png");
          var img = document.createElement("img");
          img.src = image;
          img.width = mycanvas.width;
          img.height = mycanvas.height;
          parent.appendChild(img);
          parent.removeChild(mycanvas);
          // 开始打印
          // $("#centerdiv").print();
          // 回复画布的内容
          // parent.appendChild(mycanvas);
          // 将生成的图片内容从到画布所在父元素的内容里删除
          // parent.removeChild(img);
        }
      });
      this.areaChartNameList.forEach((item) => {
        let mycanvas = document
          .getElementById(item)
          .getElementsByTagName("canvas")[0];
        if (mycanvas) {
          let parent = mycanvas.parentElement;

          let image = mycanvas.toDataURL("image/png");
          let img = document.createElement("img");
          img.src = image;
          img.width = mycanvas.width;
          img.height = mycanvas.height;
          parent.appendChild(img);
          parent.removeChild(mycanvas);
        }
      });
      setTimeout(() => {
        var oldstr = document.body.innerHTML;
        var headStr = "<html><head><title></title></head><body>";
        var footStr = "</body>";
        var content = document.getElementById("chartPage").innerHTML;
        var newStr = headStr + content + footStr;
        document.body.style.overflow = "auto";
        // document.body.innerHTML = content;
        let myWindow = window.open();
        myWindow.document.write(content);
        myWindow.print();
        // setTimeout(() => {
        //   window.print();
        // }, 3000);

        // document.body.innerHTML = oldstr;
      }, 1000);
    },
    getData() {
      this.pageRefresh = true;
      setTimeout(() => {
        this.pageRefresh = false;
      }, 500);

      ageDistributionChart({ examinationId: this.examinationId }).then(
        (data) => {
          this.chartNameList = [];
          for (let i in data.data) {
            // 只有用于制作图标的数据是字符串
            if (typeof data.data[i] == "string") {
              this.chartNameList.push(i);
              this.chartData[i] = JSON.parse(data.data[i]);
            }
          }
          console.log(this.chartNameList);
          this.chartNameList.sort();
          this.examBaseInfo = data.data.examBaseInfo;
          this.turnoverRateAndTime = data.data.turnoverRateAndTime;
          this.areaTableOption = data.data.areaOption;
          setTimeout(() => {
            this.chartInit();
          }, 1000);

          // let chart = echarts.init(document.getElementById("myChart"));
          // chart.setOption(JSON.parse(data.data.ageRateOption));
        }
      );

      detailedAnalysisByRegion({ examinationId: this.examinationId }).then(
        (data) => {
          this.areaChartNameList = [];
          data.data.forEach((item) => {
            if (typeof item.option == "string") {
              item.option = JSON.parse(item.option);
              this.areaChartNameList.push("areaChart" + item.cityString);
            }
          });
          let doubleAreaOptionList = [];
          data.data.forEach((item, idx) => {
            if (idx % 2 == 0) {
              doubleAreaOptionList.push([item]);
            } else {
              doubleAreaOptionList[parseInt(idx / 2)].push(item);
            }
          });
          this.doubleAreaOptionList = doubleAreaOptionList;
          this.areaOptionList = data.data;
          setTimeout(() => {
            this.areaChartInit();
          }, 1000);
        }
      );
    },
    areaChartInit() {
      this.areaOptionList.forEach((item) => {
        let chart = echarts.init(
          document.getElementById("areaChart" + item.cityString)
        );

        item.option.series.forEach((ii) => {
          ii.labelLayout = function (params) {
            var isLeft = params.labelRect.x < chart.getWidth() / 2;
            var points = params.labelLinePoints;
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x + params.labelRect.width / 2
              : params.labelRect.x + params.labelRect.width / 2;
            return {
              labelLinePoints: points,
              // rect: {
              x: isLeft
                ? params.labelRect.x + params.labelRect.width / 2
                : params.labelRect.x + params.labelRect.width / 4,
              // },
            };
          };
        });
        chart.setOption(item.option);
      });
      setTimeout(() => {
        this.areaPrintReady = true;
      });
    },
    chartInit() {
      this.chartNameList.forEach((item) => {
        if (Array.isArray(this.chartData[item])) {
        } else {
          let chart = echarts.init(document.getElementById(item));
          chart.setOption(this.chartData[item]);
        }
      });
      this.normalPrintReady = true;
    },
  },
  mounted() {
    getExamList().then((data) => {
      this.examList = data.data;
    });
  },
};
</script>

<style scoped lang="less"  media="print">
.wrapper {
  padding-top: 30px;
  width: 810px;
  margin: auto;
  .chartContainer {
    margin-bottom: 30px;
  }
  .areaChartListContainer {
    .areaCell {
      margin: 20px auto;
    }
  }
}
</style>
